<script>
  import { checkbox } from 'vue-strap';

  export default {
    components: { checkbox },
    props: {
      itemSolicitacao: {
        required: true
      },
      manterObservacao: {
        default: true,
        type: Boolean,
      },
      produtos: {
        required: true
      },
      tiposProdutos: {
        required: true
      },
    },
    data() {
      return {
        configuracao: this.$storage.configuracao(),
      }
    },
    computed: {
      observacaoItemCompraContador() {
        let quantidadeCaracteres = this.itemSolicitacao.observacaoItemCompra ? 
            this.itemSolicitacao.observacaoItemCompra.length : 0;

        return 500 - quantidadeCaracteres;
      },
    },
    methods: {
      validarCuidadoEspecial() {
        if (this.itemSolicitacao.naoSeAplica)
          return true;

        if (this.itemSolicitacao.controleTermico ||
          this.itemSolicitacao.fragil ||
          this.itemSolicitacao.controladoPoliciaFederal ||
          this.itemSolicitacao.solventeReagente ||
          this.itemSolicitacao.inflamavel ||
          this.itemSolicitacao.controladoExercito ||
          this.itemSolicitacao.toxico ||
          this.itemSolicitacao.vivoPerecivel)
        {
          this.$events.emit('limparEnderecoEntrega');
          return true;
        }
          
        this.$swal(
          '',
          'É necessário selecionar pelo menos um item de cuidado especial. Caso o item não necessite de cuidados especiais, selecione o item "Não se aplica"',
          'info'
        );

        throw new Error("validacao");

        return false;
      },
      validar() {
        if (this.configuracao.solCompraObrigatorioCuidadoEspecial)
          if (!this.validarCuidadoEspecial())
            return false;

        return this.$validator.validateAll();
      },
    }
  }
</script>

<template>
    <div>
        <div class="row" v-if="configuracao.obrigatorioSelecionarProduto">
            <div class="col-md-12">
                <div class="form-group required" :class="{'has-error': errors.has('tipoProduto')}">
                    <label class="control-label" for="tipoProduto">Tipo de produto</label>

                    <select class="form-control"
                            id="tipoProduto"
                            v-model="itemSolicitacao.idTipoProduto"
                            data-vv-name="tipoProduto"
                            data-vv-as="tipo de produto"
                            v-validate="'required'">
                        <option value="">Selecione...</option>
                        <option :value="tipoProduto.idTipoProduto"
                                v-for="tipoProduto in tiposProdutos">
                            {{ tipoProduto.nomeTipoProduto }}
                        </option>
                    </select>

                    <p class="text-danger" v-show="errors.has('tipoProduto')">{{ errors.first('tipoProduto') }}</p>
                </div>
            </div>
        </div>

        <div class="row" v-if="configuracao.obrigatorioSelecionarProduto">
            <div class="col-md-12">
                <div class="form-group required" :class="{'has-error': errors.has('produto')}">
                    <label class="control-label" for="produto">Produto</label>

                    <select class="form-control"
                            id="produto"
                            v-model="itemSolicitacao.idProduto"
                            data-vv-name="produto"
                            data-vv-as="produto"
                            v-validate="'required'">
                        <option value="">Selecione...</option>
                        <option :value="produto.idProduto"
                                v-for="produto in produtos">
                            {{ produto.nome }}
                        </option>
                    </select>

                    <p class="text-danger" v-show="errors.has('produto')">{{ errors.first('produto') }}</p>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xs-12">
                <div class="form-group required" :class="{'has-error': errors.has('descricaoMaterial')}">
                    <label class="control-label" for="descricao-material">Descrição do material/serviço</label>

                    <textarea class="form-control"
                              id="descricao-material"
                              v-model="itemSolicitacao.descricao"
                              v-validate="'required'"
                              data-vv-name="descricaoMaterial"
                              data-vv-as="descrição do material/serviço">
          </textarea>

                    <p class="text-danger" v-show="errors.has('descricaoMaterial')">{{ errors.first('descricaoMaterial') }}</p>
                </div>
            </div>
        </div>

        <div class="row">
            <div :class="[configuracao.utilizarValorEstimado ? 'col-xs-4' : 'col-xs-6']">
                <div class="form-group required" :class="{'has-error': errors.has('quantidade')}">
                    <label class="control-label" for="quantidade">Quantidade</label>

                    <input type="text"
                           class="form-control text-right"
                           id="quantidade"
                           v-model="itemSolicitacao.quantidade"
                           data-vv-name="quantidade"
                           v-validate="'required|not_zero'"
                           v-mascara="'moeda'">

                    <p class="text-danger" v-show="errors.has('quantidade')">{{ errors.first('quantidade') }}</p>
                </div>
            </div>
            <div :class="[configuracao.utilizarValorEstimado ? 'col-xs-4' : 'col-xs-6']">
                <div class="form-group">
                    <label class="control-label" for="unidade">Unidade</label>

                    <input type="text"
                           class="form-control"
                           id="unidade"
                           v-model="itemSolicitacao.unidade"
                           maxlength="3">
                </div>
            </div>
            <div class="col-xs-4" v-if="configuracao.utilizarValorEstimado">
                <div class="form-group required" :class="{'has-error': errors.has('valorEstimado')}">
                    <label class="control-label" for="valor-estimado">Valor unitário estimado (R$)</label>

                    <input type="text"
                           class="form-control text-right"
                           id="valor-estimado"
                           v-model="itemSolicitacao.valorEstimado"
                           data-vv-name="valorEstimado"
                           v-validate="'required|not_zero'"
                           data-vv-as="valor estimado"
                           v-mascara="'moeda'">

                    <p class="text-danger" v-show="errors.has('valorEstimado')">{{ errors.first('valorEstimado') }}</p>
                </div>
            </div>
        </div>

        <div class="row" v-if="!configuracao.solCompraOcultarObservacoes">
            <div class="col-xs-12">
                <div class="form-group">
                    <div class="checkbox">
                        <checkbox @checked="$emit('update:manterObservacao', !manterObservacao)" :value="manterObservacao" type="primary">
                            Manter observação do item de compra (caso esta solicitação
                            demandar outros itens com a mesma observação)
                        </checkbox>
                    </div>
                </div>
            </div>
        </div>

        <div class="row" v-if="!configuracao.solCompraOcultarObservacoes">
            <div class="col-xs-12">
                <div class="form-group">
                    <label class="control-label" for="observacao-item-compra">Observação do item de compra ({{ observacaoItemCompraContador }})</label>

                    <textarea class="form-control"
                              id="observacao-item-compra"
                              v-model="itemSolicitacao.observacaoItemCompra"
                              maxlength="500">
          </textarea>
                </div>
            </div>
        </div>

        <p>
            <b>
                Caso esta carga precise de algum cuidado especial durante o
                transporte ou manuseio, por favor, marque quais:
            </b>
        </p>

        <div class="row">
            <div class="col-xs-4">
                <div class="form-group">

                    <div class="checkbox">
                        <checkbox v-model="itemSolicitacao.controleTermico" value="1" type="success">
                            Controle térmico
                        </checkbox>
                    </div>

                    <div class="checkbox">
                        <checkbox v-model="itemSolicitacao.fragil" value="1" type="success">
                            Frágil
                        </checkbox>
                    </div>

                    <div class="checkbox">
                        <checkbox v-model="itemSolicitacao.controladoPoliciaFederal" value="1" type="success">
                            Controlado pela Polícia Federal
                        </checkbox>
                    </div>

                </div>
            </div>

            <div class="col-xs-4">
                <div class="form-group">

                    <div class="checkbox">
                        <checkbox v-model="itemSolicitacao.solventeReagente" value="1" type="success">
                            Solvente/Reagente
                        </checkbox>
                    </div>

                    <div class="checkbox">
                        <checkbox v-model="itemSolicitacao.inflamavel" value="1" type="success">
                            Inflamável
                        </checkbox>
                    </div>

                    <div class="checkbox">
                        <checkbox v-model="itemSolicitacao.controladoExercito" value="1" type="success">
                            Controlado pelo Exército
                        </checkbox>
                    </div>

                </div>
            </div>

            <div class="col-xs-4">
                <div class="form-group">

                    <div class="checkbox">
                        <checkbox v-model="itemSolicitacao.toxico" value="1" type="success">
                            Tóxico
                        </checkbox>
                    </div>

                    <div class="checkbox">
                        <checkbox v-model="itemSolicitacao.vivoPerecivel" value="1" type="success">
                            Vivo/Perecível
                        </checkbox>
                    </div>

                    <div class="checkbox">
                        <checkbox v-model="itemSolicitacao.naoSeAplica" value="1" type="success">
                            Não se aplica
                        </checkbox>
                    </div>

                </div>
            </div>
        </div>

    </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-compra/componentes/compartilhado/FormMateriaisDeConsumo.vue